export default __webpack_public_path__ + "static/media/480_business06-es-mobile.e962ad15.png";